var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "选择加微客服",
        width: "800px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "editRemarks overflowOuto",
        },
        [
          _c(
            "div",
            { staticClass: "search" },
            [
              _c("div", { staticClass: "searchLabel" }, [
                _vm._v("伏羲云员工姓名"),
              ]),
              _c("el-input", {
                staticClass: "w-200",
                attrs: { size: "small", placeholder: "请输入" },
                model: {
                  value: _vm.search.name,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.search,
                      "name",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "search.name",
                },
              }),
              _c(
                "div",
                { staticClass: "m-l-20" },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "small", type: "primary" } },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { attrs: { size: "small" } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "viewContent m-t-20" },
            [
              _c(
                "el-table",
                {
                  staticClass: "viewTable",
                  attrs: {
                    height: "518",
                    data: _vm.tableData,
                    "header-cell-style": { background: "#F3F3F3" },
                  },
                  on: { "row-click": _vm.handleRowClick },
                },
                [
                  _c("el-table-column", {
                    attrs: { width: "55" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-checkbox",
                              {
                                attrs: {
                                  value: Boolean(
                                    _vm.multipleSelection.find((v) => {
                                      return v.userId === row.userId
                                    })
                                  ),
                                  label: row.userId,
                                },
                              },
                              [_c("span")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "dept",
                      label: "部门名称",
                      width: "239",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "userName",
                      label: "伏羲云员工姓名",
                      align: "center",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "viewSelect" }, [
                _c("div", { staticClass: "viewSelectHeader" }, [
                  _vm._v(
                    "已选加微客服(" + _vm._s(_vm.multipleSelection.length) + ")"
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "viewSelectContent overflowOuto" },
                  _vm._l(_vm.multipleSelection, function (item, index) {
                    return _c(
                      "div",
                      { key: item.userId, staticClass: "selectItem" },
                      [
                        _c("span", { staticClass: "selectName" }, [
                          _vm._v(
                            _vm._s(item.dept) + " - " + _vm._s(item.userName)
                          ),
                        ]),
                        _c("i", {
                          staticClass: "el-icon-close closeIcon",
                          on: {
                            click: function ($event) {
                              return _vm.del(item, index)
                            },
                          },
                        }),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }